module.exports = __webpack_public_path__ + "static/img/xg2-3.d026046.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/xg2-3.png
// module id = 739
// module chunks = 0